import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { DateFormatter } from '../../dateFormat';
import WidgetsSpinner from '../../../Widgets/spinner';

// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222


export const fetchRates = (SalesOrder_id, success, failed) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v2/shipping/teapplix_quote/${SalesOrder_id}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
    .then(res => {
      if (res.data) {
        success(res.data);
      }
    }, err => {
      alert('fetch rate failed');
    })
}


const modalStyle = {
  width: '500px',
  height: '450px',
  marginLeft: '-15%',
  marginTop: '-18%',
}

const propTypes = {
  setModalVisibility: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
}

const defaultProps = {
  setModalVisibility: () => { },
  isVisible: false,
}


const ToolTipFormatter = React.createClass({
  render() {
    return (
      <span data-tip data-for={this.props.dependentValues.PromotionLine_id}>
        {this.props.value}
      </span>
    );
  },
});

const AutoApplyFormatter = React.createClass({
  render() {
    return (
      <span>
        {
          (this.props.value)
            ? 'Yes'
            : 'No'
        }
      </span>
    );
  },
});


const columns = [
  {
    key: 'Name',
    name: <Translate value="name" />,
    resizable: true,
    sortable: true,
    width: 300,
    filterable: true,
  },
  {
    key: 'Total',
    name: <Translate value="total" />,
    resizable: true,
    sortable: true,
    width: 100,
    filterable: true,
  },
];

class ShippingRate extends Component {
  state = {
    rows: [],
    isLoading: true,
    selectedRow: [],
  }

  componentDidMount() {
    this.initialRates();
  }

  initialRates = () => {
    const selectedSalesOrder = this.props.salesOrders.selectedRows[0];
    let id = selectedSalesOrder.SalesOrder_id;

    const success = ({ rates = [] }) => {
      this.setState({
        rows: rates,
        isLoading: false,
      })
    }
    const failed = () => {
      // console.log('faield');
    }

    fetchRates(id, success, failed);
  }

  onRowSelect = (row) => {
    this.setState({
      selectedRow: row
    })
  }

  handlePrintClick = () => {
    if (this.state.selectedRow[0]) {
      this.props.handleTeapplixPrintClick(this.state.selectedRow[0]);
    }
  }


  renderRatesTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    return (
      <Row>
        <Col xs={12}>
          <ReactDataGrid
            rowKey="Code"
            columns={columns}
            rowHeight={25}
            headerRowHeight={45}
            rowGetter={rowGetter}
            rowsCount={getSize()}
            minHeight={250}
            enableRowSelect='single'
            onRowSelect={this.onRowSelect}
          />
        </Col>
      </Row>
    )
  }
  render() {
    if (this.state.isLoading) return <WidgetsSpinner />;
    return (
      <div style={{ width: '100%', height: '100%', padding: '10px' }}>
        {this.renderRatesTable()}
        <div style={{ position: 'absolute', bottom: '30px', right: '20px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.props.setModalVisibility(false);
            }}
            style={{ margin: '10px' }}
          >
            <Translate value="cancel" />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.handlePrintClick();
            }}
            style={{ margin: '10px' }}
          >
            <Translate value="print" />
          </Button>
        </div>
      </div>
    )
  }
}

const ShippingRateModal = ({ setModalVisibility, isVisible, salesOrders, handleTeapplixPrintClick }) => (
  <SkyLightStateless
    title={'Rates'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <ShippingRate setModalVisibility={setModalVisibility} isVisible={isVisible} salesOrders={salesOrders} handleTeapplixPrintClick={handleTeapplixPrintClick} />
  </SkyLightStateless>
)

ShippingRateModal.propTypes = propTypes
ShippingRateModal.defaultProps = defaultProps

export default ShippingRateModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/ShippingRateModal.jsx